export const getFiltersAndParticipants = (state, sessionId) => {
  const obj = state.filtersAndParticipants[sessionId];
  return obj || {};
};
